import { API } from "aws-amplify";
import Auth from "@aws-amplify/auth";
import { store } from "../../store";

const getHeaders = async () => {
  const user = await Auth.currentAuthenticatedUser();
  const jwtToken = user.signInUserSession?.accessToken?.jwtToken;
  const headers = {};
  if (jwtToken) headers['Authorization'] = 'Bearer ' + jwtToken;
  const { loginReducer } = store.getState();
  const clientId = loginReducer?.groups?.[0];
  if (clientId) headers['BluStream-Client-ID'] = clientId;
  return headers;
};

const customerUuid = () => {
  const { loginReducer } = store.getState();
  return loginReducer?.groups?.[0];
};

export const getEventMappings = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/event-mappings`, { headers });
};

export const getEnabledEventMappings = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/event-mappings/enabled`, { headers });
};

export const createEventMapping = async (mapping) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/event-mappings`, { headers, body: mapping });
};

export const getEventMapping = async (mappingId) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/event-mappings/${mappingId}`, { headers });
};

export const updateEventMapping = async (mappingId, mapping) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.put("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/event-mappings/${mappingId}`, { headers, body: mapping });
};

export const deleteEventMapping = async (mappingId) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.del("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/event-mappings/${mappingId}`, { headers });
};

export const getMappingTemplates = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/mapping-templates`, { headers });
};

export const applyTemplate = async (templateId) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/apply-template/${templateId}`, { headers });
};

export const getEventCapabilities = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/client/${uuid}/capabilities?type=EVENT`, { headers });
};
